export class Series{
    name: string; 
    data: any[]; 
    stack?: string; 
    showInLegend?: boolean 
}